import { PaymentSplitChoice } from "@tSurya/Common/Utilities/paymentBreakdown";
import { createContext, useContext } from "react";

export interface SurCheckoutPaymentContextValue {
    paymentSplitChoice: PaymentSplitChoice;
    setPaymentSplitChoice: (choice: PaymentSplitChoice) => void;
}

const noop = () => {
    /* Default no-op used when a consumer renders outside the provider. */
};

export const defaultSurCheckoutPaymentContextValue: SurCheckoutPaymentContextValue = {
    paymentSplitChoice: "prepayMgbwOnly",
    setPaymentSplitChoice: noop,
};

export const SurCheckoutPaymentContext = createContext<SurCheckoutPaymentContextValue>(defaultSurCheckoutPaymentContextValue);

export const useSurCheckoutPayment = (): SurCheckoutPaymentContextValue => useContext(SurCheckoutPaymentContext);
